export const EMAIL_REGEX = "[a-z0-9]+@[a-z]+.[a-z]{2,3}";

export const PASSWORD_REGEX =
  "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$";

export const ALPHABET_REGEX = /^[a-zA-Z ]*$/;

export const AVOID_SPECIAL_CHARACTER = /^([a-zA-Z0-9 _-]+)$/;
